import CustomHeader from "component/CustomHeader";
import NewDashboardLayout from "../../component/layout/NewDashboardLayout";
import emptyState from 'asset/images/emptyState.svg';

const EmptyState = ({ title = "Bill Payments" }) => {
    return (
        <div className="w-full">
            <CustomHeader title="Bill Payment" />
            <div className="bg-white min-h-[80vh] flex flex-col rounded-xl items-center justify-center">
                <img src={emptyState} alt="No Data" className="h-[240px] w-[295px]" />
                <div className="text-center">
                    <p className="mb-2 text-xl font-[450] text-main-dark">Launching soon</p>
                    <p className="text-sm font-light text-secondary-40">
                        We’re fine-tuning things behind the scenes. <br />
                        You’ll be able to pay bills right from Tradevu.
                    </p>
                </div>
            </div>
        </div>
    );
};

const BillPayment = () => {
    return (
        <NewDashboardLayout>
            <div className="flex flex-col items-center justify-center w-full h-full">
                <EmptyState title="Bill Payments" />
            </div>
        </NewDashboardLayout>
    );
};

export default BillPayment;
